/* eslint-disable */
// @ts-nocheck
import { Grid, Box, useTheme } from '@mui/material';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import LoginPageAnimation from '../../components/Login/LoginPageAnimation';
import Particles from 'react-particles';
import { loadSlim } from 'tsparticles-slim';
import useCommon from '../../Hooks/useCommon';
import useColorPallete from '../../Hooks/Settings/useColorPallete';
import { withTransaction } from '@elastic/apm-rum-react';
import { ReactComponent as NimbusLogo } from '../../assets/images/NimbusUnoLogo.svg';
/**
 * @function LoginGraphic
 * @description The login page for the application
 * @params {object} history - the history object used to navigate between pages
 * @returns {React.Component} - React component
 */
const LoginGraphic = ({ _history }) => {
  const [activeStep, setActiveStep] = React.useState(0);
  const { common } = useCommon();
  const { getCurrentTheme, currentSavedTheme } = useColorPallete();

  const theme = useTheme();
  useEffect(() => {
    getCurrentTheme();
  }, []);
  useEffect(() => {
    setTimeout(() => {
      getCurrentTheme();
    }, 500);
  }, [common.triggerHeaderIconChange, common.triggerProductIconChange]);
  const particlesInit = React.useCallback(async (engine) => {
    // console.log(engine);
    // you can initiate the tsParticles instance (engine) here, adding custom shapes or presets
    // this loads the tsparticles package bundle, it's the easiest method for getting everything ready
    // starting from v2 you can add only the features you need reducing the bundle size
    //await loadFull(engine);
    await loadSlim(engine);
  }, []);
  const particlesLoaded = React.useCallback(async (container) => {
    await console.log(container);
  }, []);
  useEffect(() => {
    const browserLogo = currentSavedTheme?.browser_icon;
    if (browserLogo) {
      let link = document.querySelector("link[rel~='icon']");
      if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.getElementsByTagName('head')[0].appendChild(link);
      }
      link.href = browserLogo;
    }
  }, [currentSavedTheme]);
  return (
    <Grid
      item
      xs={12}
      sm={12}
      md={6}
      sx={(_theme) => ({
        background: '#0c3270',
      })}
      px={8}
      py={5}
    >
      <Particles
        id="tsparticles"
        init={particlesInit}
        loaded={particlesLoaded}
        height="100vh"
        width="50vw"
        style={{
          position: 'absolute',
          left: 0,
          top: 0,
          width: '50vw',
        }}
        options={{
          fpsLimit: 120,
          interactivity: {
            events: {
              onDiv: {
                selectors: '#loginFormCards',
                enable: false,
                mode: 'repulse',
                type: 'square',
              },
              onClick: {
                enable: false,
                mode: 'push',
              },
              onHover: {
                enable: false,
                mode: 'repulse',
              },
              resize: true,
            },
            modes: {
              push: {
                quantity: 4,
              },
              repulse: {
                distance: 200,
                duration: 0.4,
              },
            },
          },
          particles: {
            color: {
              value: '#AECDFC',
            },
            links: {
              color: '#AECDFC',
              distance: 150,
              enable: true,
              opacity: 0.2,
              width: 1,
            },
            move: {
              direction: 'none',
              enable: true,
              outModes: {
                default: 'bounce',
              },
              random: true,
              speed: 1,
              straight: false,
            },
            number: {
              density: {
                enable: true,
                area: 800,
              },
              value: 80,
            },
            opacity: {
              value: 0.1,
            },
            // shape: {
            //   type: 'circle',
            // },
            size: {
              value: { min: 1, max: 5 },
            },
          },
          detectRetina: true,
          fullScreen: {
            enable: false,
            zIndex: 0,
          },
        }}
      ></Particles>
      <Grid item xs={12} height="100%">
        <Box display="flex" flexDirection="row" height="100%" flexGrow={1}>
          <Box
            display="flex"
            flexDirection="column"
            alignItems="flex-start"
            maxWidth="650px"
            flexGrow={1}
            marginX="auto"
            role="img"
            aria-label="NIMBUS UNO"
          >
            <NimbusLogo
              height="60px"
              width="120px"
              style={{ color: theme.palette.other.white }}
            />

            <Box
              width="inherit"
              display="flex"
              flexGrow={1}
              alignItems="center"
            >
              <LoginPageAnimation />
            </Box>
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};
LoginGraphic.propTypes = {
  _history: PropTypes.oneOfType([PropTypes.object]).isRequired,
};

export default withTransaction('LoginGraphic', 'component')(LoginGraphic);
